import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1.25 5.5h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1zm22.26.57a.48.48 0 0 0-.48 0l-6 3a.51.51 0 0 0-.28.45v5A.51.51 0 0 0 17 15l6 3a.51.51 0 0 0 .72-.45V6.5a.52.52 0 0 0-.21-.43Z"
}), 'MeetingCamera');